// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { createContext, useContext } from 'react';

// Alan widget'larinin FORMUN BUTUNUNE (kalemler, baslik degerleri) erisebilmesi icin baglam.
// Ornek: zengin metin editorundeki "Kalemlerdeki urun gorsellerini ekle" dugmesi kalem
// satirlarindan urun id'lerini okur. Widget imzasi degismez — baglam useContext ile okunur.

export interface FormDataSnapshot {
  readonly values: Record<string, unknown>;
  readonly collections: Record<string, readonly Record<string, unknown>[]>;
}

const EMPTY: FormDataSnapshot = { values: {}, collections: {} };

export const FormDataContext = createContext<FormDataSnapshot>(EMPTY);

export function useFormData(): FormDataSnapshot {
  return useContext(FormDataContext);
}
